const currentEnv = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';

const getApiUrl = () => {
  if (currentEnv === 'production') {
   
    const currentHost = window.location.origin; 
    return `${currentHost}/api`;
  }
  
  
  return 'http://localhost:3001';
};

const config = {
  development: {
    API_URL: 'http://localhost:3001',
    NODE_ENV: 'development'
  },
  production: {
    API_URL: getApiUrl(),
    NODE_ENV: 'production'
  }
};

export const env = {
  API_URL: config[currentEnv]?.API_URL || config.development.API_URL,
  NODE_ENV: currentEnv,
  IS_DEVELOPMENT: currentEnv === 'development',
  IS_PRODUCTION: currentEnv === 'production',
};

// Debug uniquement
console.log('🔍 Variables d\'environnement détectées:');
console.log('  - REACT_APP_NODE_ENV:', process.env.REACT_APP_NODE_ENV);
console.log('  - NODE_ENV:', process.env.NODE_ENV);
console.log('  - Environnement final:', currentEnv);
console.log('  - Host actuel:', window.location.origin);
console.log('🌍 Configuration finale:', env);